import React, {useContext, useMemo, useState} from 'react'
import OfferEspdTypeSwitch from "./OfferEspdTypeSwitch";
import {OfferEspdType} from "./constants/OfferEspdType";
import OfferEspdInternal from "./OfferEspdInternal";
import OfferEspdExternal from "./OfferEspdExternal";
import {createSelectItem} from "components/Select";
import Tr from "translations/Translations";
import OfferEspdTable from "./OfferEspdTable";
import PropTypes from "prop-types";
import {OfferMode} from "../../../../common/constants/OfferMode";
import {RoundType} from "constants/RoundType";
import PurchaserOfferContext from "context/PurchaserOfferContext";
import SupportModeContext from "context/SupportModeContext";

function OfferEspd(
    {
        offerEdit,
        mode,
        disabled,
        roundType,
        section,
    }) {
    const purchaserOfferContext = useContext(PurchaserOfferContext);
    const supportMode = useContext(SupportModeContext);
    const [espdType, setEspdType] = useState(offerEdit.envelopeOffer ? OfferEspdType.EXTERNAL : OfferEspdType.INTERNAL);
    const modifyDisabled = disabled || mode === OfferMode.PLACED;

    const positionItems = useMemo(() => {
        const pos = offerEdit.espdOnPositions ? offerEdit.positions.map(x => createSelectItem(x.positionId, Tr("part_x", {x: x.order}) + ': ' + x.name)) : [];
        pos.unshift(createSelectItem("", ""));
        return pos;
    }, [offerEdit.positions, offerEdit.espdOnPositions]);

    return (
        <>
            {
                !modifyDisabled && <>
                    <OfferEspdTypeSwitch setEspdType={setEspdType} espdType={espdType} disabled={offerEdit.envelopeOffer}/>
                    <OfferEspdInternal disabled={purchaserOfferContext?.preview || supportMode} offerEdit={offerEdit} visible={espdType === OfferEspdType.INTERNAL} positionItems={positionItems}/>
                    <OfferEspdExternal disabled={purchaserOfferContext?.preview || supportMode} offerEdit={offerEdit} visible={espdType === OfferEspdType.EXTERNAL} positionItems={positionItems}/>
                </>
            }

            <OfferEspdTable roundType={roundType} disabled={disabled} offerEdit={offerEdit} mode={mode} section={section} />
        </>
    )
}

OfferEspd.propTypes = {
    disabled: PropTypes.bool.isRequired,
    mode: PropTypes.oneOf(Object.keys(OfferMode)).isRequired,
    roundType: PropTypes.oneOf(Object.keys(RoundType)).isRequired
};

export default OfferEspd;